import React, { useCallback, useRef, useState } from "react";
import DataGrid, { Column, FilterRow, HeaderFilter, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem, } from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { Card } from "react-bootstrap";
import { getAllGoldProductInventoryData } from "../services/gold-product-inventory.service";
import { HttpStatus } from "modules/core";
import { UpdateInventoryReturnDataIds } from "modules/inward/diamond-product-inventory/model";
import { updateGoldAndDiamondInventoryRecords } from "utils/inward";
import notistack from "modules/core/notistack";
import { useNavigate } from "react-router-dom";
import { HasPermission } from "Layout/Permissions/permissionsCache";

const GoldProductInventory = () => {
    let setSelectedRows: Array<number> = [];
    const dataGridRef = useRef<DataGrid>(null);
    const navigate = useNavigate()

    const dataSource = new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
            try {
                const { searchValue, skip, take } = loadOptions;
                const parameterList = new URLSearchParams();
                if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                if (typeof take === 'number') parameterList.append('take', take.toString());
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }
                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
                parameterList.append("MaterialType", 'gold');
                parameterList.append("IsSNMCC", 'false');
                parameterList.append("IsReceived", 'true');
                const response = await getAllGoldProductInventoryData(parameterList);
                // return {
                //     data: response?.data || [],
                //     totalCount: response?.data.length || 0,
                // };
                return response;
            } catch (error) {
                console.error("Data loading error:", error);
                return { data: [], totalCount: 0 };
            }
        }
    });

    const renderSerialNumber = useCallback((cellData: any) => {
        const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
        return <span>{rowIndex}</span>;
    }, []);

    const handleSelectionChange = (e: any) => {
        setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
    };

    const [isSubmitting, setIsSubmitting] = useState(false);
    const updateDiamondAndGoldInventory = async () => {
        try {
            setIsSubmitting(true);
            if (setSelectedRows.length > 0) {
                const model = new UpdateInventoryReturnDataIds();
                model.returnToMayaveProductIdList = setSelectedRows;
                const response = await updateGoldAndDiamondInventoryRecords(model);
                if (response.status === 200) {
                    dataGridRef.current?.instance.clearSelection();
                    dataGridRef.current?.instance.refresh();
                    notistack.notifyFromApi(response);
                    navigate('/return-request');
                } else {
                    notistack.notifyFromApi(response);
                }
            } else {
                notistack.warning("Please Select Product");
            }
        } catch (error) {
            console.error("Failed to fetch inward Data:", error);
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Gold Product Inventory</h5>
                            {HasPermission('ProductHeader.Write') && <button onClick={updateDiamondAndGoldInventory} className="submit-btn" disabled={isSubmitting}>
                                Return
                            </button>}
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission('ProductHeader.Read') &&
                                <DataGrid
                                    dataSource={dataSource}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    columnAutoWidth={true}
                                    ref={dataGridRef}
                                    showBorders={true}
                                    onSelectionChanged={handleSelectionChange}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Selection
                                        mode="multiple"
                                    />
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Pager

                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total: {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />
                                    <Column
                                        caption="Sr.No."
                                        dataType="number"
                                        alignment="center"
                                        cellRender={renderSerialNumber}
                                    />
                                    <Column allowFiltering={true} dataField="storeCode" caption="Store Code" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="invoiceNo" caption="Invoice No." dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="invoiceDate" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" width={150} />
                                    <Column allowFiltering={true} dataField="categoryName" caption="Category Name" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="styleNo" caption="Style Number" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="metalColor" caption="Metal Color" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="metalKT" caption="Metal KT" dataType="string" width={150} />
                                    <Column allowFiltering={false} dataField="grossWt" format="#,##0.000" caption="Gross Weight" dataType="number" width={150} />
                                    <Column allowFiltering={false} dataField="netWt" format="#,##0.000" caption="Net Weight" dataType="number" width={150} />
                                    <Column allowFiltering={false} dataField="qty" caption="Quantity" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="huid" caption="HUID" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="bagNo" caption="BagNo." dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="purchaseRate" format="#,##0.00" caption="Purchase Rate" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="complexityName" caption="Complexity Name" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="complexityValue" format="#,##0.00" caption="Complexity Value" dataType="number" width={150} />
                                    <Column allowFiltering={true} dataField="labMrp" format="#,##0.00" caption="Lab Mrp" dataType="number" width={150} />
                                    <Column allowFiltering={true} dataField="goldMrp" format="#,##0.00" caption="Gold Mrp" dataType="number" width={150} />
                                    <Column allowFiltering={true} dataField="mrpPrice" format="#,##0.00" caption="Product Mrp" dataType="number" width={150} />
                                    <Column allowFiltering={true} dataField="dpPrice" format="#,##0.00" caption="DP" dataType="number" width={150} />
                                    <Column allowFiltering={false}
                                        dataField="isSRP"
                                        caption="Is SRP" dataType="boolean"
                                        width={150}
                                        cellRender={({ data }) => (
                                            <span>{data?.isSRP ? "SRP" : "MRP"}</span>
                                        )} />

                                </DataGrid>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    );
}
export default GoldProductInventory;